export default {"src":"/_next/static/media/up_caret.79eee298.svg","height":24,"width":24};